import { sql } from 'drizzle-orm';
import { date, index, pgTable, text, timestamp, uniqueIndex, uuid, varchar } from 'drizzle-orm/pg-core';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';

import { organisations } from './schema-security.js';

export const brokerEngineAssignments = pgTable(
  'crm_x_brokerengine_assignments',
  {
    id: uuid('id').primaryKey().default(sql`gen_random_uuid()`),
    organisationId: uuid('organisation_id').notNull().references(() => organisations.id, { onDelete: 'cascade' }),
    sourceEventId: text('source_event_id').notNull(),
    brokerengineApplicationId: text('brokerengine_application_id').notNull(),
    title: varchar('title', { length: 500 }).notNull(),
    brokerengineApplicationUrl: text('brokerengine_application_url').notNull(),
    assigneeFullName: varchar('assignee_full_name', { length: 255 }).notNull(),
    assignedUserId: text('assigned_user_id').notNull(),
    applicationName: varchar('application_name', { length: 255 }),
    dueDate: date('due_date'),
    priority: varchar('priority', { length: 20 }),
    payloadHash: varchar('payload_hash', { length: 64 }).notNull(),
    createdAt: timestamp('created_at', { withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp('updated_at', { withTimezone: true }).defaultNow().notNull(),
  },
  (table) => ({
    organisationEventUnique: uniqueIndex('crm_x_brokerengine_assignments_org_event_unique').on(
      table.organisationId,
      table.sourceEventId,
    ),
    organisationAssigneeIndex: index('crm_x_brokerengine_assignments_org_assignee_idx').on(
      table.organisationId,
      table.assignedUserId,
    ),
  }),
);

export const insertBrokerEngineAssignmentSchema = createInsertSchema(brokerEngineAssignments);
export const selectBrokerEngineAssignmentSchema = createSelectSchema(brokerEngineAssignments);

export type BrokerEngineAssignment = typeof brokerEngineAssignments.$inferSelect;
export type InsertBrokerEngineAssignment = typeof brokerEngineAssignments.$inferInsert;
